import env from '@/env';

// 商品组
function wareopsUpdateRules({ activityId, planCode, poolId }: any) {
  return `//${env.WAREOPS_DOMAIN}/#/channel/job-list?collectActivityId=${activityId}&promotionActivityId=${planCode}&recWarePoolId=${poolId}`;
}

// 发起选品
function pandoraZCXuanpin(planCode: string) {
  return `/pandora/#/integration/pool/entry?from=acore&planCode=${planCode}`;
}

function pandoraFactory(fieldId: string) {
  const query = fieldId ? `?fieldId=${fieldId}` : '';
  return `/trend-operation/trend-manage/business-realm/factory#/integration/batchcreate${query}`;
}

export default {
  wareopsUpdateRules,
  pandoraZCXuanpin,
  pandoraFactory,
};
